(() => {
  function moveHelmetHelp() {
    const productGrid = document.querySelector('.product.grid, .product');
    if (!productGrid) return;

    const sizeBlock = document.querySelector('.driftaholic-helmet-size-help');
    const accessoryBlock = document.querySelector('.driftaholic-helmet-accessories');
    if (!sizeBlock && !accessoryBlock) return;

    let target = productGrid.querySelector(':scope > .driftaholic-helmet-under-media');
    if (!target) {
      target = document.createElement('div');
      target.className = 'driftaholic-helmet-under-media';
      productGrid.appendChild(target);
    }

    if (sizeBlock && sizeBlock.parentElement !== target) target.appendChild(sizeBlock);
    if (accessoryBlock && accessoryBlock.parentElement !== target) target.appendChild(accessoryBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveHelmetHelp, { once: true });
  } else {
    moveHelmetHelp();
  }
})();
